import { authHeaders } from '../lib/apiFetch';
/**
 * What-If API client
 */
const API_BASE = process.env.REACT_APP_API_BASE || '';

export async function computeWhatIf(baseRequest, adjustments, valuationId = null) {
  try {
    const response = await fetch(`${API_BASE}/api/what-if`, {
      method: 'POST',
      headers: await authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ base_request: baseRequest, adjustments, valuation_id: valuationId }),
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.detail || `HTTP ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('What-If API error:', error);
    return { success: false, error: error.message };
  }
}
